export type CabinTypeSorterProps = {
  id: string;
  sortingLabel: string;
  sortingCodes?: SortingOption[];
  showSorterOnDesktop?: boolean;
  showSorterOnMobile?: boolean;
  arrowAriaLabel?: string;
};

export type SortingOption = {
  optionLabel: string;
  optionValue: SortingOptionEnum;
};

export enum SortingOptionEnum {
  Relevance = 'relevance',
  Ascending = 'asc',
  Descending = 'desc',
}

export enum Prestigiousness {
  Interior = 'INS',
  OceanView = 'OUT',
  Balcony = 'BAL',
  Suite = 'SUI',
  MSCYachtClub = 'YTC',
}

export type SortingState = { cabinTypeSorter: SortingOption };
